import React from 'react';
import { Card, Row, Col, Space, Collapse, Tag } from 'antd';
import { NumberOutlined } from '@ant-design/icons';
const { Panel } = Collapse;

// 结算信息
function CheckoutInfo(props: any) {
    const { cart, error } = props || {};
    const { shippingMethodOptions, shippingMethod, shippingMethodLabel } =  cart?.groups?.[0] || {};
    const { sections, totalCost, totalDiscount } = cart?.groups?.[0]?.layout?.itemizedSections || {};
    const currentShippingMethod = shippingMethodOptions?.find(item => item?.name === shippingMethod);

    if(!cart) return null;

    return <Card title="结算信息" style={{ width: '100%' }}>
        <Space direction="vertical" size='middle' style={{ width: '100%' }}>
            {error ? <Tag color="error">无法购买</Tag> : <Tag color="success">可以购买</Tag>}
            {error ? `错误原因：${error?.messages?.join('，')}` : null}
            <h6>应付金额：{totalCost?.[0]?.text}</h6>
            <Collapse defaultActiveKey="1">
                {sections && sections?.length ? sections?.map(section => {
                    const { itemized } = section || {};
                    const node =  itemized?.map(item => {
                        const { label, subItemized, text } = item || {};
                        return (
                            <Panel header={<span>{getText(label)}：{getText(text)}</span>} key="1">
                                {subItemized && subItemized.length ? subItemized?.map(subItem => {
                                    if(subItem?.type !== 'SPLIT_LINE') {
                                        return (
                                            <div>{getText(subItem?.label)}：{getText(subItem?.text)}</div>
                                        )
                                    }
                                    return null;
                                }) : '无'}
                            </Panel>
                        )
                    })
                    return node;
                }) : null}
                {currentShippingMethod && <Panel header={`国际物流：${shippingMethodLabel}`} key="1">
                    {currentShippingMethod?.itemized?.map(item => {
                        return (
                            <div>{item?.label}{item?.costValue ? '：' + item?.costValue : ''}</div>
                        )
                    })}
                </Panel>}
            </Collapse>
        </Space>
    </Card>
}

function getText(textArr) {
    return (
        <span>
            {textArr?.map(text => {
                let style = {};
                if(text?.strike) {
                    style = {
                        textDecoration: 'line-through'
                    }
                }
                return <span style={style}>{text?.text}</span>
            })}
        </span>
    )
}

export default CheckoutInfo;